import { BaseItem } from '../common';

export enum Kind {
  LabelCommand = 'LABEL_COMMAND',
  StructureField = 'STRUCTURE_FIELD',
}

export interface BaseValues {
  noteTranscriptId: string;
  charStartIndex: number;
  charEndIndex: number;
  kind: Kind;
}

export type UpdateValues = Partial<BaseValues>;

export interface NoteTranscriptSegment extends BaseItem, BaseValues {}
